import { test, enforce, create } from 'vest'
import validators from '../../../utils/validators'

enforce.extend({
  isValidEmail: validators.validateEmail,
})

export const formValidation = create((data = {}) => {
  const { email, password } = data

  test('email', 'Email must be valid!', () => {
    enforce(email).isValidEmail()
  })
  test('password', 'Password can not be empty!', () => {
    enforce(password).isNotEmpty()
  })
})
